import React from 'react';
import Video from 'twilio-video';
import { Container, Link, Typography, Paper, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledGrid = styled(Grid)({
  marginTop: '2.5em',
});

const StyledPaper = styled(Paper)({
  padding: '1em',
});

const Heading = styled(Typography)({
  marginBottom: '0.4em',
});

export default function UnsupportedBrowserWarning({ children }: { children: React.ReactElement }) {
  if (!Video.isSupported) {
    return (
      <Container>
        <StyledGrid container justifyContent="center">
          <Grid size={{ xs: 12, sm: 6 }}>
            <StyledPaper>
              <Heading variant="h4">
                Browser or context not supported
              </Heading>
              <Typography>
                Please open this application in one of the{' '}
                <Link
                  href="https://www.twilio.com/docs/video/javascript#supported-browsers"
                  target="_blank"
                  rel="noopener"
                >
                  supported browsers
                </Link>
                .
                <br />
                If you are using a supported browser, please ensure that this app is served over a{' '}
                <Link
                  href="https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts"
                  target="_blank"
                  rel="noopener"
                >
                  secure context
                </Link>{' '}
                (e.g. https or localhost).
              </Typography>
            </StyledPaper>
          </Grid>
        </StyledGrid>
      </Container>
    );
  }

  return children;
}
